export const blobToBase64 = (blob: Blob) => {
  if (blob) {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    return new Promise<string | null>((resolve) => {
      reader.onloadend = () => {
        resolve(reader.result as string | null);
      };
    });
  }
  return null;
};
